/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OldDate } from './oldDate';


export interface Milestone { 
    stepId: string;
    stepLabel: string;
    durationInHours: number;
    dueDate: string;
    dueTime: string;
    oldDates?: Array<OldDate>;
}

